import { render, staticRenderFns } from "./entrada.vue?vue&type=template&id=0d8b8b90&"
import script from "./entrada.vue?vue&type=script&lang=js&"
export * from "./entrada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports